import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import * as moment from "moment";
import { Subject } from 'rxjs';
import { SharedModalService } from '../service/shared-modal.service';
import { switchMap } from 'rxjs/operators';
import { PropertyViewService } from '@app/features/customers/customer/property-view/service/property-view.service';
import { of, Observable } from 'rxjs';
import { CsToastBoxService } from '@app/services';
import {AuthService, SettingsService} from "@app/core";
import {CsActivityLogEventService} from "@app/shared/cs-activity-log/cs-activity-log-event.service";
import {ActivityAddTagComponent} from "@app/shared/activity-add-tag/activity-add-tag.component";
declare var $: any;

@Component({
    selector: 'app-scheduled-activity-modal',
    templateUrl: './scheduled-activity-modal.component.html',
    styleUrls: ['../../shared/communication-modals/communication-modal.scss']
})
export class ScheduledActivityModalComponent implements OnInit {
    scheduleForm: FormGroup;
    //   listActivity: any = [];
    showContent;
    modalBack;
    selectedActivityType: number = 1;
    selectedDate: string = 'Today';
    customDate: any = [];
    selectedId: any;
    selectedText: any;
    selectedCustomDate: any;

    select2Config = { width: '100%', dropdownCssClass: 'scheduled-activity-add-tag' };
    assignee: any;
    //   assigneeList: any = [];
    //   scheduledData: any;
    deleted_array: Array<any> = [];
    subscriptions: any = {};
    activityDateEdit: any;
    scheduleEditDate: any;
    completed: boolean = true;
    mytime: any;
    editId: any;
    dateValuesChanged: boolean = false;
    scheduleButtonDisabled: boolean = false;
    minDate = new Date();
    editDateTime: any = '';
    @Input() showActivityModal: boolean = false;
    @Input() opportunityId: number;
    @Input() scheduledData: any;
    @Input() listActivity: any;
    @Input() assigneeList: any;
    @Output() onSave: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Input() isCommonRoute: boolean = false;
    @Input() isCallFromCsActivityLog = false;    // Note: This is used for modification according to `cs-activity-log.component`
    scheduledTime: any;
    timepickerChangeEvent = new Subject();
    recordBasedAssigneeList: any;
    assigneesId: any;
    screenType: any;
    tablePkId: any;
    countryDetails:any;
    afterSave: (data) => void;
    newRefreshData:any;
    showTemplateList = false;
    screenLabel = 'Call note template';
    showAddNewTemplate = false;
    selectedCallNoteTemplate = null;
    IssetTemplateData:boolean = false;
    @ViewChild('useTemplate') useTemplate;
    tagsList = [];
    selectedTags:any[] = [];
    removed_tag = [];
    showMeridian: boolean = true;
    select2AssigneeConfig: any = {};
    @ViewChild(ActivityAddTagComponent) tagDropdownComponent!: ActivityAddTagComponent;
    selectedTagLists: any[] = [];
    constructor(
        private sharedModalService: SharedModalService,
        private fb: FormBuilder,
        private opportunityService: AddOpportunityService,
        @Inject('confirmationBoxHelper') private confirmationBoxHelper,
        private propertyService: PropertyViewService,
        private toast: CsToastBoxService,
        @Inject('$scope') private ajsScope,
        private settingsService: SettingsService,
        private _alEvent: CsActivityLogEventService,
        private authService: AuthService,
        private cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
        const intlSettings = this.settingsService.getIntlSettings();
        this.showMeridian = parseInt(intlSettings['time']) === 0;
        this.sharedModalService.getHashTagsList().subscribe((response: any) => {
            this.tagsList = response.hashtags;
        });
        this.initCalender();
        this.sharedModalService.scheduledActivityDetails$.subscribe((activityData: any) => {
            if (activityData) {
                this.sharedModalService.updateModalStatus('others', 'activity', activityData.showActivityModal);
                if(activityData.showActivityModal == false){
                    this.closeModalWithoutConfirmation()
                } else{
                    $(".modal-dialog").removeClass("modal-dialog-open");
                }
                this.isCommonRoute = activityData.isCommonRoute || false;
                this.showActivityModal = activityData.showActivityModal || '';
                this.listActivity = activityData.listActivity || '';
                this.assigneeList = activityData.assigneeList || '';
                this.scheduledData = activityData.scheduledData || null;
                this.screenType = activityData.screenType || '';
                this.tablePkId = activityData.tablePkId || '';
                this.opportunityId = activityData.opportunityId || '';
                this.isCallFromCsActivityLog = activityData['isCallFromCsActivityLog'] || false;
                this.IssetTemplateData = activityData['scheduledData'] === null;
                this.selectedCallNoteTemplate = null;
                if(activityData['scheduledData']) {
                    this.selectedCallNoteTemplate = activityData['scheduledData']['template'];
                    if(this.selectedCallNoteTemplate) {
                        this.selectedCallNoteTemplate.templateName = activityData['scheduledData']['template']['name'];
                        this.selectedCallNoteTemplate.templateId = activityData['scheduledData']['templateId'];
                    }
                    if (this.scheduledData.savedTags) {
                        this.selectedTags = this.scheduledData.savedTags.length > 0 ? this.scheduledData.savedTags.map((t: any) => t.id.toString()) : [];
                        this.selectedTagLists = this.scheduledData.savedTags.length > 0 ? this.scheduledData.savedTags : [];
                    }
                }
                this.afterSave = activityData['afterSave'] || null;
                this.openActivityModal();
            }
            this.select2AssigneeConfiguration(activityData.assigneeList);
        })
    }

    openModal(){
        setTimeout(() => {
            if ($.fn.modal && $.fn.modal.Constructor) {
                $.fn.modal.Constructor.prototype.enforceFocus = function () {};
            }
            const modalInstance = $('#modalPopUp').data('bs.modal');
            if (modalInstance) {
                modalInstance._config.focus = false;
            }
            $('#modalPopUp').modal({backdrop: false,keyboard: false,focus: false});
            $(".modal-header").css("background", "#5E7F7D");
            $('.activityModal__').modal('show');
            $(".modal-dialog").addClass("modal-dialog-open");
            const el = document.querySelector('.schedule-activity-description') as HTMLElement;
            if (el) {
                el.focus();
            }

            const assignToElement = document.querySelector('#s2id_assignTo') as HTMLElement;
            if (assignToElement) {
                assignToElement.addEventListener('click', () => {
                    assignToElement.style.borderBottom = '1px solid var(--Base-structure-Stroke, #E1E1E1)';
                    this.updateDropdownPosition(assignToElement, 'scheduled-activity-assignee-dropdown', 118);
                });
                const assignToInput = assignToElement.querySelector('.select2-search-field input') as HTMLElement;
                if (assignToInput) {
                    assignToInput.addEventListener('input', () => {
                        this.updateDropdownPosition(assignToElement, 'scheduled-activity-assignee-dropdown', 118);
                    });
                    assignToInput.addEventListener('keyup', () => {
                        this.updateDropdownPosition(assignToElement, 'scheduled-activity-assignee-dropdown', 118);
                    });
                }
            }
        }, 500);
    }

    openActivityModal() {
        this.recordBasedAssigneeList = this.assigneeList;
        if (this.showActivityModal) {
            this.countryDetails = this.settingsService.getCountryCode();
            if (!this.scheduledData || this.scheduledData == 'reschedule') {
                this.buildForm();
                this.openModal();
            }
            else {
                if (this.scheduledData.checked) {
                    if (this.scheduledData.activityCompleted) {
                        this.completed = false
                    } else {
                        this.completed = true;
                    }
                }
                if (this.scheduledData.isScheduled) {
                    let selectedActivity = null;
                    this.buildForm()
                    this.openModal()
                    if (this.listActivity) {
                        selectedActivity = this.listActivity.find((item: any) => item.name == this.scheduledData.activityType)
                        this.selectedActivityType = selectedActivity.id;
                    }
                    if (selectedActivity) {
                        this.scheduleForm.controls['activityType'].setValue(selectedActivity.id)
                    }
                    this.scheduleForm.controls['description'].setValue(this.scheduledData.description)
                    this.scheduleForm.controls['notes'].setValue(this.scheduledData.notes)
                    if (this.scheduledData.recordType == 'Opportunities') {
                        this.recordBasedAssigneeList = this.recordBasedAssigneeList.filter(item => item.salesroleid !== '8' && item.salesroleid !== null);
                    } else {
                        //sales dispatcher license role is 8, we are restricting lite user to assign scheduled activity
                        this.recordBasedAssigneeList = this.recordBasedAssigneeList.filter(item => !(item.salesroleid === '8' && item.jmsroleid === null));
                    }
                    if (this.scheduledData.assignees.length != 0) {
                        const assignedUserId = [];
                        for (let i = 0; i < this.scheduledData.assignees.length; i++) {
                            assignedUserId.push(this.scheduledData.assignees[i].id);
                        }
                        // below set of code to handle select plugin issue while restricting record based assignee
                        setTimeout(function () {
                            const dataSet = [];
                            $('#assignTo').find('option').each(function (key, val) {
                                const rowData = $(val).val();
                                const assigneeArray = rowData.split(': ').pop();
                                const checkKey = assignedUserId.includes(parseInt(assigneeArray, 10));
                                if (checkKey) {
                                    dataSet.push(rowData);
                                }
                            });
                            $('#assignTo').val(dataSet).trigger('change');
                        }, 500);
                    }

                    if (this.scheduledData.savedTags.length != 0) {
                        const assignedTagId = [];
                        for (let i = 0; i < this.scheduledData.savedTags.length; i++) {
                            assignedTagId.push(this.scheduledData.savedTags[i].id);
                        }
                        setTimeout(function () {
                            const tagSet = [];
                            $('#tagTo').find('option').each(function (key, val) {
                                const tagData = $(val).val();
                                const tagArray = tagData.split(': ').pop();
                                const checkKey = assignedTagId.includes(parseInt(tagArray, 10));
                                if (checkKey) {
                                    tagSet.push(tagData);
                                }
                            });
                            $('#tagTo').val(tagSet).trigger('change');
                        }, 500);
                    }

                    const dateToShow = this.scheduledData.dateToShow['date'] ? this.scheduledData.dateToShow['date'] : this.scheduledData.dateToShow;
                    var date = new Date(dateToShow);
                    var scheduledDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    this.activityDateEdit = scheduledDate;
                    if (this.activityDateEdit) {
                        $('#scheduledDate').addClass('input-width');
                        $('#scheduledDate').removeClass('input-date-width')
                        $('#scheduledDate').removeClass('date-width');
                    }
                    if(this.countryDetails['code'] == 44) {
                        this.selectedDate = moment(dateToShow).format('DD/MM/YYYY');
                    } else if(this.countryDetails['code'] == 1){
                        this.selectedDate = moment(dateToShow).format('MM/DD/YYYY');
                    }
                    this.scheduleEditDate = this.selectedDate;
                    this.scheduleForm.controls['scheduledDate'].setValue(this.selectedDate);
                    let editDate = new Date(moment(dateToShow).format('YYYY-MM-DD HH:mm:ss'));
                    this.scheduleForm.controls['scheduleTime'].setValue(editDate);
                    this.editDateTime = editDate;
                    this.scheduleForm.updateValueAndValidity();
                    $(".modal-header").css("background", "#5E7F7D")
                    $('.activityModal__').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open")
                }
                else {
                    this.closeModalWithoutConfirmation()
                }
            }

        } else {
            this.closeModalWithoutConfirmation(false);
        }
    }

    buildForm() {
        this.dateValuesChanged = true;
        this.scheduleForm = this.fb.group({
            'assigneeIds': [''],
            'notes': [''],
            'description': ['', Validators.required],
            'scheduledDate': [''],
            'scheduleTime': [''],
            'activityType': [1],
            'tagIds':['']
        });
        this.scheduleForm.get('scheduledDate').setValue(this.selectedDate);
        this.selectedActivityType = 1
        this.scheduleForm.get('activityType').setValue(this.selectedActivityType);
        let momentTime = moment();
        let reminder = 15 - (momentTime.minute() % 15);
        if (reminder == 15) {
            reminder = 0;
        }
        let roundTime = moment(momentTime).add(reminder, "minutes").format();
        const time = new Date(roundTime);
        this.scheduleForm.controls['scheduleTime'].setValue(time);
        this.scheduleForm.controls['scheduledDate']
            .valueChanges.subscribe((value) => {
                if (this.dateValuesChanged) {
                    let momentCurrentTime: any = moment();
                    let reminder = 0;
                    if (value == 'Today') {
                        reminder = 15 - (momentCurrentTime.minute() % 15);
                        if (reminder == 15) {
                            reminder = 0;
                        }
                    }
                    else if (!this.editDateTime) {
                        momentCurrentTime = moment().toDate();
                        momentCurrentTime.setHours(8);
                        momentCurrentTime.setMinutes(0);
                    }
                    else {
                        momentCurrentTime = this.editDateTime;
                    }
                    let roundTime = moment(momentCurrentTime).add(reminder, "minutes").format();
                    const time = new Date(roundTime);
                    this.scheduleForm.controls['scheduleTime'].setValue(time);
                    this.scheduleTime(time)
                    this.editDateTime = '';
                    this.cdr.detectChanges();
                }
            });
        // }
    }

    initCalender() {
        let date = Date.now();
        let momentBusinessDays = require("moment-business-days");
        let tomorrow = '(' + momentBusinessDays(date).businessAdd(2).format("dddd") + ')';
        let business2days = '(' + momentBusinessDays(date).businessAdd(3).format("dddd") + ')';
        let nextmonday = '(' + moment(date).add(1, 'week').day(1).format("MMMM DD") + ')';
        let oneweek = '(' + moment(date).add(7, 'days').format("MMMM DD") + ')';
        let twoweeks = '(' + moment(date).add(14, 'days').format("MMMM DD") + ')';
        let onemonth = '(' + moment(date).add(1, 'M').format("MMMM DD") + ')';
        let threemonths = '(' + moment(date).add(3, 'M').format("MMMM DD") + ')';
        let sixmonths = '(' + moment(date).add(6, 'M').format("MMMM DD") + ')';
        this.customDate = [{ 'id': 1, 'text': "Today", 'view_text': 'Today', 'name': '' },
        { 'id': 2, 'text': 'Tomorrow', 'view_text': 'Tomorrow', 'name': '' },
        { 'id': 3, 'text': 'in.business.days', 'text_days': '2', 'view_text': 'in.2.business.days', 'name': tomorrow },
        { 'id': 4, 'text': 'in.business.days', 'view_text': 'in.3.business.days', 'text_days': '3', 'name': business2days },
        { 'id': 5, 'text': 'next.monday', 'view_text': 'next.monday', 'text_days': 'Next', 'name': nextmonday },
        { 'id': 6, 'text': 'in.1.week', 'view_text': 'in.1.week', 'text_days': '1', 'name': oneweek },
        { 'id': 7, 'text': 'in.weeks', 'view_text': 'in.2.weeks', 'text_days': '2', 'name': twoweeks },
        { 'id': 8, 'text': 'in.1.month', 'view_text': 'in.1.month', 'text_days': '1', 'name': onemonth },
        { 'id': 9, 'text': 'in.months', 'view_text': 'in.3.months', 'text_days': '3', 'name': threemonths },
        { 'id': 10, 'text': 'in.months', 'view_text': 'in.6.months', 'text_days': '6', 'name': sixmonths },
        { 'id': 10, 'text': 'Custom date', 'view_text': 'Custom_date' }];
    }

    scheduleTime(time) {
        if (time instanceof Date && time.toString() != 'Invalid Date') {
            return this.scheduleForm.value.scheduleTime.toLocaleTimeString(['en-GB'], { timeStyle: 'short' })
        }
        else if (this.scheduledTime) {
            return this.scheduledTime;
        }
        else {
            return time
        }
    }

    selectedType(type) {
        this.selectedActivityType = type.id;
        this.scheduleForm.controls['activityType'].setValue(type.id);
        this.selectedCallNoteTemplate = null;
    }

    closeModal(emitEvent = true) {
        // this.buildForm()
        if (this.useTemplate != undefined) {
            this.useTemplate.filterParams.search = '';
            this.useTemplate.filterParams.parentId = '';
            this.useTemplate.searchValue = '';
            this.useTemplate.selectedFolder = '';
            this.useTemplate.getTemplatesList();
        }
        $(".template-wrapper").removeClass("template-open");
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the schedule activity?', this.ajsScope)
            .then(() => {
                this.closeModalWithoutConfirmation(emitEvent);
                this.sharedModalService.updateModalStatus('others', 'activity', false);
                this.selectedCallNoteTemplate = null;
            }).catch(() => { });
        this.selectedText = '';
    }

    closeModalWithoutConfirmation(emitEvent = true) {
        this.dateValuesChanged = false;
        this.assignee = undefined
        $("#assignTo").val(null).trigger("change");
        $("#tagTo").val(null).trigger("change");
        if (this.scheduleForm) {
                this.scheduleForm.controls['assigneeIds'].setValue('');
                this.scheduleForm.controls['scheduledDate'].setValue('');
                this.scheduleForm.controls['scheduleTime'].setValue('');
                this.cdr.detectChanges();
            $('.activityModal__').modal('hide');
            $(".modal-dialog").removeClass("modal-dialog-open");
        }
        this.completed = false;
        this.editId = null;
        this.selectedTags = [];
        this.selectedTagLists = [];
        this.scheduledData = undefined;
        this.activityDateEdit = '';
        this.selectedDate = 'Today';
        this.sharedModalService.setCommonModalEmittedValue(false);
        if (emitEvent)
            this.onClose.emit(false);

        if (this.isCallFromCsActivityLog) {
            this._alEvent.resetActivityEventData();
        }
        if (this.tagDropdownComponent) {
            this.tagDropdownComponent.ngOnDestroy();
        }
    }

    getFilterByDate(id, text, name) {
        $('#dropdownd1').removeClass('dropdown');
        this.selectedId = id;
        if (this.selectedId == '1' || this.selectedId == '2') {
            $('#scheduledDate').addClass('input-width')
            $('#scheduledDate').removeClass('input-date-width')
            $('#scheduledDate').removeClass('date-width');
            this.selectedDate = text;
            this.selectedText = text;
            $('#caret-up').addClass('up-caret-icon');
        }
        else {
            let inputText = text.charAt(0).toUpperCase() + text.slice(1);
            this.selectedText = inputText.split('.').join('');
            this.selectedDate = inputText.split('.').join(' ') + " " + name;
            if (this.selectedId == '3' || this.selectedId == '4') {
                $('#caret-up').addClass('up-caret-icon');
                $('#caret-up').removeClass('dropdown-list-caret-icon');

            }
            else {
                $('#scheduledDate').addClass('input-date-width');
                $('#scheduledDate').removeClass('date-width');
                $('#scheduledDate').removeClass('input-width');
            }
        }
    }

    selectedCustom() {
        $('#dropdownd1').addClass('dropdown');
    }

    dateCreated($event) {
        this.selectedDate = 'Custom date';
        this.selectedText = 'CustomDate';
        $('#caret-up').addClass('up-caret-icon');
        this.selectedCustomDate = $event;
    }

    getAssignee(data) {
        if (data) {
            let assigneeArray = [];
            for (var i = 0; i < data.length; i++) {
                assigneeArray.push(data[i].split(':')[1].trim().replace(/['"]+/g, ''))
            }
            this.assignee = assigneeArray;
        }
    }
    getTags(data){
        if (data) {
            let tagArray = [];
            for (var i = 0; i < data.length; i++) {
                tagArray.push(data[i].split(':')[1].trim().replace(/['"]+/g, ''))
            }
            this.selectedTags = tagArray;
        }
    }

    scheduledActivity() {
        $(".template-wrapper").removeClass("template-open");
        let scheduledData;
        this.dateValuesChanged = false;
        this.scheduleButtonDisabled = true;
        if (this.selectedText == 'CustomDate') {
            this.scheduleForm.value['scheduledDate'] = this.selectedCustomDate;
        }
        else {
            this.dateConversion(this.selectedText);
            this.selectedText = '';
        }
        if (this.scheduleForm.value['scheduledDate']) {
            let date = this.scheduleForm.value['scheduledDate'].toLocaleDateString('en-GB');
            this.scheduleForm.controls['scheduledDate'].setValue(date.replaceAll("/", "/"));
        }
        if (this.scheduleForm.value['scheduleTime']) {
            let time = this.scheduleForm.value['scheduleTime'].toLocaleTimeString('en-GB');
            let arr = time.split(':').slice(0, -1).join(":");
            time = arr + "";
            this.scheduledTime = time;
            this.scheduleForm.controls['scheduleTime'].setValue(time);
        } else {
            this.scheduleForm.controls['scheduleTime'].setValue("00:00:00");
        }

        this.deleted_array = [];
        let url;
        this.scheduledData = this.scheduledData ? this.scheduledData : null;
        if (this.scheduledData != null && this.scheduledData != 'reschedule') {
            if (this.scheduledData.hasOwnProperty('isScheduled')) {
                if (this.scheduledData.assignees.length != 0) {
                    let selectedAsignees = [];
                    for (var i = 0; i < this.scheduledData.assignees.length; i++) {
                        selectedAsignees.push(this.scheduledData.assignees[i]['id']);
                    }
                    let new_array;
                    if (this.assignee && selectedAsignees) {
                        let assignee = this.assignee.map(Number);
                        new_array = assignee.filter(f => !selectedAsignees.includes(f));
                        this.deleted_array = selectedAsignees.filter(f => !assignee.includes(f))
                    }
                    if (new_array) {
                        this.scheduleForm.controls['assigneeIds'].setValue(new_array)
                    } else {
                        this.scheduleForm.controls['assigneeIds'].setValue([])
                    }
                }
                else {
                    this.scheduleForm.controls['assigneeIds'].setValue(this.assignee);
                }

                if (this.scheduledData.savedTags.length != 0) {
                    // let selectedtags = [];
                    // for (var i = 0; i < this.scheduledData.savedTags.length; i++) {
                    //     selectedtags.push(this.scheduledData.savedTags[i]['id']);
                    // }
                    //
                    // let selectedValues = $('#tagTo').val();
                    // let resultArray = [];
                    // if(selectedValues != null){
                    //     resultArray = selectedValues.map(item => item.split(': ').pop());
                    // }
                    this.scheduleForm.controls['tagIds'].setValue(this.selectedTags);
                }
                else {
                    this.scheduleForm.controls['tagIds'].setValue(this.selectedTags);
                }
                scheduledData = this.scheduleForm.value;
                if (this.deleted_array) {
                    scheduledData.deletedAssigneeIds = this.deleted_array;
                } else {
                    scheduledData.deletedAssigneeIds = []
                }
                url = `sales/editScheduleActivity/${this.scheduledData.activityId}`
            }
        }
        else {
            this.scheduleForm.controls['assigneeIds'].setValue(this.assignee);
            this.scheduleForm.controls['tagIds'].setValue(this.selectedTags);
            scheduledData = this.scheduleForm.value;
            url = `sales/scheduleOpportunityActivity/${this.opportunityId}`
        }
        let logId = null;
        if (this.scheduledData) {
            logId = this.scheduledData.logId;
        }
        scheduledData = this.scheduleForm.value;
        // Date format change
        let scheduledDate = moment(scheduledData['scheduledDate'], "DD-MM-YYYY").format("MM-DD-YYYY");
        scheduledDate = scheduledDate + " " + scheduledData['scheduleTime'];
        let new_date = new Date(scheduledDate);
        scheduledData['scheduled_date'] = new_date;
        scheduledData['callNoteTemplateId'] = this.selectedCallNoteTemplate && +(this.selectedCallNoteTemplate.templateId) || null;
        if (this.isCommonRoute) {
            this.scheduleButtonDisabled = false;
            if (this.scheduledData != null && this.scheduledData != 'reschedule') {
                scheduledData.scheduleId = this.scheduledData.activityId;
            }

            scheduledData.logId = logId;
            scheduledData.screenType = this.screenType;
            scheduledData.tablePkId = this.tablePkId;
            this.onActivityScheduleSave(scheduledData);
        }
        else {
            this.opportunityService.createScheduledActivity(scheduledData, url).subscribe(
                (res) => {
                    this.onSave.emit(this.scheduledData);
                    this.scheduleButtonDisabled = false;
                    if (this.scheduledData) {
                        if (this.scheduledData != null && this.scheduledData.hasOwnProperty('runThroughActivity')) {
                            this.sharedModalService.refreshCompleteActivity('reschedule');
                        } else if (this.scheduledData.hasOwnProperty('edit')) {
                            this.sharedModalService.refreshCompleteActivity('update');
                        }
                    }
                    this.closeModalWithoutConfirmation();
                    this.sharedModalService.setStatusUpdated('true');
                },
                error1 => {
                    console.log(error1);
                });
            this.sharedModalService.updateModalStatus('others', 'activity', false);
        }
        this.selectedText = '';
        // this.selectedCallNoteTemplate = null;
    }

    onActivityScheduleSave(data: any) {
        const saveObservable = data.hasOwnProperty('scheduleId') ?
            this.propertyService.saveEditScheduledActivity(data, data['scheduleId']) :
            this.propertyService.saveScheduledActivity(data);
        this.propertyService.timelineRefresh$.subscribe((refreshData: any) => {
            this.newRefreshData = refreshData;
        });
        saveObservable.pipe(
            switchMap(savedData => {
                const scheduledSnapshot = this.scheduledData;
                const shouldRefreshRunThroughReschedule = scheduledSnapshot != null && scheduledSnapshot.hasOwnProperty('runThroughActivity');
                const shouldRefreshRunThroughUpdate = scheduledSnapshot != null && scheduledSnapshot.hasOwnProperty('edit');

                let refreshData: any = {
                        fromDate: "",
                        isSearch: false,
                        object: "",
                        page: 1,
                        search: "",
                        toDate: "",
                        userId: "",
                        screen:this.screenType,
                };
                refreshData['data'] = {
                    screen: data.hasOwnProperty('logId') && data.logId ? 'editActivity' : 'addScheduleActivity',
                    type: data.hasOwnProperty('scheduleId') ? 'update' : 'add',
                    values: null,
                    id: data.hasOwnProperty('logId') && data.logId ? data.logId : 'latest'
                };

                if (this.isCallFromCsActivityLog) {
                    if (this.afterSave) this.afterSave(data);
                } else {
                    // this.propertyService.setRefreshSliderScheduleActivity(true);
                    if(this.screenType == 'jobs' || this.screenType == 'jobs_tab'){
                        this.propertyService.setTimelineRefresh(this.newRefreshData);
                    }else {
                        this.propertyService.setTimelineRefresh(refreshData);
                    }
                }

                if (shouldRefreshRunThroughReschedule) {
                    this.sharedModalService.refreshCompleteActivity('reschedule');
                } else if (shouldRefreshRunThroughUpdate) {
                    this.sharedModalService.refreshCompleteActivity('update');
                }

                this.sharedModalService.updateModalStatus('others', 'activity', false);
                this.showToast(data.hasOwnProperty('scheduleId') ? 'Scheduled activity updated' : 'Scheduled activity added');
                // Return an observable to satisfy switchMap
                return new Observable<void>((observer) => {
                    observer.next();
                    observer.complete();
                });
            })
        ).subscribe(res => {
            this.closeModalWithoutConfirmation();
        });
        this.sharedModalService.setStatusUpdated('true');
    }

    showToast(msg) {
        this.toast.show(msg, 1500);
    }

    dateConversion(data) {
        let momentBusinessDays = require("moment-business-days");
        let today = new Date();
        if (data == 'Today') {
            let date = moment(today);
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'Tomorrow') {
            let date = moment(today).add(1, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In2businessdays') {
            let date = momentBusinessDays(today).businessAdd(2, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In3businessdays') {
            let date = momentBusinessDays(today).businessAdd(3, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'Nextmonday') {
            let date = moment(today).add(1, 'week').day(1);
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In1week') {
            let date = moment(today).add(7, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In2weeks') {
            let date = moment(today).add(14, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In1month') {
            let date = moment(today).add(1, 'M');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In3months') {
            let date = moment(today).add(3, 'M');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else if (data == 'In6months') {
            let date = moment(today).add(6, 'M');
            this.scheduleForm.value['scheduledDate'] = date['_d']
        }
        else {
            if (this.selectedDate == 'Today') {
                let today = new Date();
                let date = moment(today);
                this.scheduleForm.value['scheduledDate'] = date['_d'];
                $('#caret-up').addClass('up-caret-icon');
            }
            else {
                this.scheduleForm.value['scheduledDate'] = this.activityDateEdit;
            }
        }
    }

    omitSpecialChar(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    timepickerIncrement(event) {
        if (event == 'time') {
            let element = $('.hour-min').first();
            let hour = element.find('option:selected')
            let newHour = '';
            if (!hour.next().length) {
                newHour = '00';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newHour = hour.next().val();
                hour.next().prop('selected', 'selected');
            }
            let changeObject = { hour: newHour };
            this.timepickerChangeEvent.next(changeObject);
        }
        else if (event == 'min') {
            let element = $('.hour-min').last();
            let min = element.find('option:selected');
            let newMin = '';
            if (!min.next().length) {
                newMin = '00';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newMin = min.next().val();
                min.next().prop('selected', 'selected');
            }
            let changeObject = { min: newMin };
            this.timepickerChangeEvent.next(changeObject);
        }
    }

    timepickerDecrement(event) {
        if (event == 'time') {
            let element = $('.hour-min').first();
            let hour = element.find('option:selected')
            let newHour = '';
            if (!hour.prev().length) {
                newHour = '23';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newHour = hour.prev().val();
                hour.prev().prop('selected', 'selected');
            }
            let changeObject = { hour: newHour };
            this.timepickerChangeEvent.next(changeObject);
        }
        else if (event == 'min') {
            let element = $('.hour-min').last();
            let min = element.find('option:selected');
            let newMin = '';
            if (!min.prev().length) {
                newMin = '45';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newMin = min.prev().val();
                min.prev().prop('selected', 'selected');
            }
            let changeObject = { min: newMin };
            this.timepickerChangeEvent.next(changeObject);
        }
    }
    showTemplateOptions() {
        $(".template-wrapper").addClass("template-open");
        this.showTemplateList = true;
        $("#emailcontent").addClass("overlay");
    }

    cancelTemplate() {
        $("#emailcontent").removeClass("overlay");
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    }

    setTemplateDetails(selectedTemplate) {
        console.log('st', selectedTemplate);
        this.selectedCallNoteTemplate = selectedTemplate;
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    }

    hasAmPm(value: string): boolean {
        return /am|pm/i.test(value);
    }
    convertTo24Hour(timeString: string): string {
        const [time, modifier] = timeString.toLowerCase().split(" ");
        let [hours, minutes] = time.split(":").map(Number);

        if (modifier === "pm" && hours !== 12) {
            hours += 12;
        }

        if (modifier === "am" && hours === 12) {
            hours = 0;
        }

        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
    }
    convertToDateObject(time24: string): Date {
        const [hours, minutes] = time24.split(":").map(Number);
        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
    }

    timeChange(event: string) {
        let time24;
        if (this.hasAmPm(event)) {
            // Case: 10:30 am / 10:30 pm
            time24 = this.convertTo24Hour(event);
        } else {
            // Case: 10:30 or 22:30
            time24 = event;
        }

        const dateObj = this.convertToDateObject(time24);
        this.scheduleForm.patchValue({
            scheduleTime: dateObj
        });

        this.scheduleTime(dateObj);
    }

    select2AssigneeConfiguration(assigneeList) {
        this.select2AssigneeConfig = {
            width: '240px',
            dropdownCssClass: "scheduled-activity-assignee-dropdown",
            formatResult: function (data) {
                let assignee: any;
                if (assigneeList && assigneeList.length > 0) {
                    assignee = assigneeList.find(item => item.id == data.id.split(': ')[1]);
                }
                let element: any;
                if (assigneeList && assignee.profilepicture) {
                    element = $('<span><img src="' + assignee.profilepicture + '" style="width: 24px;height: 24px;border-radius: 50%;" /> ' + data.text + '</span>');
                } else {
                    const initials = data.text.split(' ');
                    const firstInitial = initials[1] ? initials[1][0].toUpperCase() : '';
                    const secondInitial = initials[2] ? initials[2][0].toUpperCase() : '';
                    element = $('<span><span style="width: 24px;height: 24px;border-radius: 50%;background: #F2994A; color: white; font-size: 10px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center;">'
                         + firstInitial + secondInitial + '</span>' + data.text + '</span>')
                }
                return element;
            },
            formatSelection: function (data) {
                let assignee: any;
                if (assigneeList && assigneeList.length > 0) {
                    assignee = assigneeList.find(item => item.id == data.id.split(': ')[1]);
                }
                if (assigneeList && assignee.profilepicture) {
                    return `<div style="font-size: 12px; color: #505b65;">
                                <img src="${assignee.profilepicture}" style="width: 14px; height: 14px; border-radius: 50%;" />
                                ${data.text}
                            </div>`;
                } else {
                    const initials = data.text.split(' ');
                    const firstInitial = initials[1] ? initials[1][0].toUpperCase() : '';
                    const secondInitial = initials[2] ? initials[2][0].toUpperCase() : '';
                    return `<div style="display: flex; font-size: 12px; color: #505b65;">
                                <span style="width: 14px; height: 14px; border-radius: 50%; background: #F2994A; color: white; font-size: 8px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; margin-right: 4px;">
                                    ${firstInitial}${secondInitial}
                                </span>
                                ${data.text}
                            </div>`;
                }
            }
        }
    }

    updateDropdownPosition(element: any, dropdownClass: string, offsetBottom: number): void {
        if (element) {
            const searchInput = element.querySelector('.select2-search-field') as HTMLElement;
            if (searchInput) {
                const rect = searchInput.getBoundingClientRect();
                const dropdown = document.body.querySelector(`.${dropdownClass}`) as HTMLElement;
                if (dropdown) {
                    dropdown.style.left = `${rect.left + 10}px`;
                    dropdown.style.bottom = `${offsetBottom}px`;
                }
            }
        }
    }

    onTagSelected(tag: any) {
        this.selectedTags.push(tag.id.toString());
    }

    onTagRemoved(tag: any) {
        this.selectedTags = this.selectedTags.filter(t => t != tag.id.toString());
    }

    showScheduleTime(time) {
        if (time instanceof Date && time.toString() != 'Invalid Date') {
            const hours = time.getHours();
            const minutes = time.getMinutes();
            const paddedHours = hours.toString().padStart(2, '0');
            const paddedMinutes = minutes.toString().padStart(2, '0');

            if (this.showMeridian) {
                // Format as 12-hour with AM/PM
                let hour12 = hours % 12;
                if (hour12 === 0) {
                    hour12 = 12;
                }
                const meridian = hours >= 12 ? 'PM' : 'AM';
                return `${hour12.toString().padStart(2, '0')}:${paddedMinutes} ${meridian}`;
            } else {
                // Format as 24-hour
                return `${paddedHours}:${paddedMinutes}`;
            }
        }
        else if (this.scheduledTime) {
            return this.scheduledTime;
        }
        else {
            return time
        }
    }

}
